import { createAction } from "redux-actions";

import scrollTop from "../../../shared/scroll_to_top_of_page";

export const FOCUS_VIEW_OVERVIEW = "overview";
export const FOCUS_VIEW_PARAMETER_DETAIL = "parameterDetail";
export const FOCUS_VIEW_TYPES = [FOCUS_VIEW_OVERVIEW, FOCUS_VIEW_PARAMETER_DETAIL];

export const SWITCH_TO_PARAMETER_DETAIL = "SWITCH_TO_PARAMETER_DETAIL";
export const switchToParameterDetail = createAction(SWITCH_TO_PARAMETER_DETAIL);

export const regulationStandardClick = dispatch => (country, parameter, purpose) => () => {
  scrollTop();
  dispatch(switchToParameterDetail({ country, parameter, purpose, focusViewType: FOCUS_VIEW_PARAMETER_DETAIL }));
};

export const BREADCRUMBS_CLICK_OVERVIEW = "BREADCRUMBS_CLICK_OVERVIEW";
export const breadcrumbsClickOverview = createAction(BREADCRUMBS_CLICK_OVERVIEW);
export const overviewClick = dispatch => () => () => {
  scrollTop();
  dispatch(breadcrumbsClickOverview({ focusViewType: FOCUS_VIEW_OVERVIEW }));
};

export const BREADCRUMBS_CLICK_PARAMETER = "BREADCRUMBS_CLICK_PARAMETER";
export const breadcrumbsClickParameter = createAction(BREADCRUMBS_CLICK_PARAMETER);
export const parameterClick = () => () => () => {
  // dispatch(breadcrumbsClickParameter({ focusViewType: FOCUS_VIEW_PARAMETER_DETAIL }));
};

